module.exports = __webpack_public_path__ + "static/media/poll-h.62030afb.svg";